import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import jobService from './jobService'


 

const initialState = {
  
  data:   [],
  isError: false,
  isSuccess: false,
  isLoading: false, 
  message: '',
  error: '',

  dataID:   [],
  isErrorID: false,
  isSuccessID: false,
  isLoadingID: false, 
  messageID: '',
  errorID: '',

  datacreate:   [],
  isErrorcreate: false,
  isSuccesscreate: false,
  isLoadingcreate: false,
  userTokencreate:null,
  messagecreate: '',
  errorcreate: '',
}

 

// Get all jobs
export const getalljobs = createAsyncThunk('job/getalljobs', async ( data,thunkAPI) => {
  try {
    return await jobService.getalljobs()
  } catch (error:any) {
    const message =
      error.response &&
        error.response.data ?
        error.response.data.errors[0].message :
        error.message  
    return thunkAPI.rejectWithValue(message)
  }
})
// Get all jobs by ID
export const getalljobsbyID = createAsyncThunk('job/getalljobsbyID', async ( id,thunkAPI) => {
  try {
    return await jobService.getalljobsbyID(id)
  } catch (error:any) {
    const message =
      error.response &&
        error.response.data ?
        error.response.data.errors[0].message :
        error.message 
    return thunkAPI.rejectWithValue(message)
  }
})

// Creact Job
export const createjob = createAsyncThunk('job/createjob', async (data, thunkAPI) => {
  try {
    return await jobService.createjob(data)
  } catch (error:any) {
    const message =
       error.response &&
        error.response.data ?
        error.response.data.errors[0].message :
        error.message 
     return thunkAPI.rejectWithValue(message)
  }
})


 

export const jobSlice = createSlice({
  name: 'job',
  initialState,
  reducers: {
    reset: (state) => {  

      state.isLoading = false
      state.isSuccess = false
      state.isError = false
      state.message = '' 

      state.isLoadingID = false
      state.isSuccessID = false
      state.isErrorID = false
      state.messageID = '' 

      state.isLoadingcreate = false
      state.isSuccesscreate = false
      state.isErrorcreate = false
      state.messagecreate = '' 
    },
    
     
  },
  extraReducers: (builder) => {
    builder 
      .addCase(getalljobs.pending, (state) => {
        state.isLoading = true
        
      })
      .addCase(getalljobs.fulfilled, (state, action) => {
        state.isLoading = false
        state.isSuccess = true
        state.data= action.payload 
      })
      .addCase(getalljobs.rejected, (state:any, action) => {
        state.isLoading = false
        state.isError = true
        state.message = action.payload
        state.data = [] 
      })
      .addCase(getalljobsbyID.pending, (state) => {
        state.isLoadingID = true
        
      })
      .addCase(getalljobsbyID.fulfilled, (state, action) => {
        state.isLoadingID = false
        state.isSuccessID = true
        state.dataID= action.payload 
      })
      .addCase(getalljobsbyID.rejected, (state:any, action) => {
        state.isLoadingID = false
        state.isErrorID = true
        state.messageID = action.payload
        state.dataID = [] 
      })
    
    // Creact Job 
      .addCase(createjob.pending, (state) => {
        state.isLoadingcreate = true 
      })
      .addCase(createjob.fulfilled, (state:any, action) => {
        state.isLoadingcreate = false
        state.isSuccesscreate = true
        state.datacreate = action.payload 
      })
      .addCase(createjob.rejected, (state:any, action) => {
        state.isLoadingcreate = false
        state.isErrorcreate = true
        state.messagecreate = action.payload
        state.datacreate = [] 
      })
      
  },
})

export const { reset } = jobSlice.actions
export default jobSlice.reducer